import { Button } from 'components/Button/Button';
import type { FC } from 'react';
import type { AppTranslations } from 'translations/translations';

interface Props {
  hasTokenSet: boolean;
  msg: AppTranslations;
  openDialog: () => void;
}

export const ApiTokensHeader: FC<Props> = ({
  hasTokenSet,
  msg,
  openDialog,
}) => (
  <>
    {!hasTokenSet && msg.settings.apiTokens.noApiToken}
    {msg.settings.apiTokens.helpUsage}
    <Button
      variant='secondary'
      icon='fa-plus'
      type='button'
      onClick={openDialog}
    >
      {msg.settings.apiTokens.btnAdd}
    </Button>
  </>
);
